import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { SharedStoreState } from "./SharedStoreState"
import { IProviderConfig } from "../types/provider/IProvider"

export interface IProviderStoreAddition {
    providers: IProviderSliceState
}

interface IProviderSliceState {
    providerConfigs: { [organizationId: string]: IProviderConfig[] | undefined }
}

const initialState: IProviderSliceState = {
    providerConfigs: {}
}

export const providerSlice = createSlice({
    name: "provider",
    initialState,
    reducers: {
        setConfigs: (state, action: PayloadAction<{ merchantId: string; configs: IProviderConfig[] }>) => {
            state.providerConfigs[action.payload.merchantId] = action.payload.configs
        },
    },
})

export const providerActions = providerSlice.actions
export const providerSelectors = {
    configs: (state: SharedStoreState, merchantId: string) => state.providers.providerConfigs[merchantId],
}
